export function formatRevenue(
  revenue: number | null | undefined,
  t: any,
  currency: string = "USD",
): string {
  if (revenue === null || revenue === undefined) return "NA";

  const getCurrencySymbol = (curr: string) => {
    switch (curr.toUpperCase()) {
      case "USD":
        return "$";
      case "EUR":
        return "€";
      case "GBP":
        return "£";
      case "JPY":
        return "¥";
      default:
        return curr + " ";
    }
  };

  const symbol = getCurrencySymbol(currency);

  if (revenue >= 1.0e12) {
    return `${symbol}${(revenue / 1.0e12).toFixed(2)}T`;
  }
  if (revenue >= 1.0e9) {
    return `${symbol}${(revenue / 1.0e9).toFixed(2)}B`;
  }
  if (revenue >= 1.0e6) {
    return `${symbol}${(revenue / 1.0e6).toFixed(2)}M`;
  }
  if (revenue >= 1.0e3) {
    return `${symbol}${(revenue / 1.0e3).toFixed(2)}K`;
  }
  return `${symbol}${revenue.toFixed(2)}`;
}

export function formatTime(timeVal: string, t: any): string {
  if (!timeVal) return "";
  const upTime = timeVal.toUpperCase();
  if (upTime === "AMC") return t("After Market Close");
  if (upTime === "BMO") return t("Before Market Open");

  // Basic validation for existing standard HH:mm times
  return timeVal;
}

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}
